import {
	Alert,
	AlertType,
	BellIcon,
	useCloseOnOutsideAndEsc,
} from '@gurupay/gp-ui-library';
import type { IAnnouncement } from '@hooks/useAnnouncements';
import clsx from 'clsx';
import { useRef } from 'react';

interface NotificationsProps {
	className?: string;
	announcements: IAnnouncement[] | undefined;
}

export const Notifications = ({ announcements, className }: NotificationsProps) => {
	const notificationsContainerRef = useRef<HTMLDivElement>(null);

	const { isOpened: isNotificationsOpen, setIsOpened: setIsNotificationsOpen } =
		useCloseOnOutsideAndEsc([notificationsContainerRef], true);

	if (!announcements?.length) {
		return null;
	}

	return (
		<div
			ref={notificationsContainerRef}
			className={clsx(
				'relative w-max opacity-0 pointer-events-none transition-opacity duration-300',
				'has-[.notification-alert]:opacity-100 has-[.notification-alert]:pointer-events-auto',
				className,
			)}
		>
			<div
				className="relative z-10 flex justify-center items-center w-10 h-10 rounded-full cursor-pointer bg-brand-primary-50 text-brand-primary-800"
				onClick={() => setIsNotificationsOpen((prevState) => !prevState)}
			>
				<BellIcon />
			</div>

			<div
				className={clsx(
					'fixed top-18 inset-x-0 bottom-0 z-10 bg-black/50',
					'md:absolute md:inset-auto md:top-space-48 md:right-0 md:bg-transparent md:z-auto',
					'transition-opacity duration-300',
					isNotificationsOpen ? 'opacity-100' : 'opacity-0 pointer-events-none',
				)}
				onClick={() => setIsNotificationsOpen(false)}
			>
				<div
					className="
						absolute top-space-16 left-1/2 -translate-x-1/2
						space-y-space-8 w-full px-space-16
						md:static md:translate-x-0 md:w-82 md:px-0
					"
					onClick={(event) => event.stopPropagation()}
				>
					{announcements.map((item) => (
						<Alert
							key={item.id}
							className="notification-alert md:max-w-82"
							id={item.id}
							isClosable={item.type === AlertType.INFO}
							title={item.title}
							type={item.type === 'announcement' ? AlertType.ERROR : AlertType.INFO}
						>
							<p className="mt-space-8">{item.text}</p>
						</Alert>
					))}
				</div>
			</div>
		</div>
	);
};
